import React from 'react';
import {CardActions, CreateButton, Datagrid, Filter, List, ReferenceField, TextField, TextInput} from 'react-admin';
import {
    BillAuthStatusField,
    DateTimeField,
    DownloadFileContentButton,
    DownloadTemplateFileButton,
    EditButtonWithAuthStatus,
    HocKiField
} from "../../components";


const CustomerSubjectResultBatchFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         displayedFilters,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {/* Add your custom actions */}
        <DownloadTemplateFileButton basePath="/api/customerSubjectResultBatch/getTemplate" btnLabel="ra.action.downloadTemplate"/>
        <CreateButton basePath={basePath}/>
    </CardActions>
);

export const CustomerSubjectResultBatchList = props => (
    <List filters={<CustomerSubjectResultBatchFilter/>} {...props} actions={<PostActions/>} bulkActionButtons={false}>
        <Datagrid>
            <TextField source="id"/>
            <ReferenceField source="unitId" reference="clazzes" allowEmpty>
                <TextField source="name" />
            </ReferenceField>
            <HocKiField source="hocKi"/>
            <TextField source="description"/>
            <DateTimeField source="lastUpdatedOn" format="DD-MM-YYYY HH:mm" width={'7%'}/>
            <TextField source="lastUpdatedBy"/>
            <BillAuthStatusField source="authStatus"/>
            <DownloadFileContentButton/>
            <EditButtonWithAuthStatus/>
        </Datagrid>
    </List>
);

export default CustomerSubjectResultBatchList
